import { token } from '@terra/ui-styled-system';
import {
  BookOpen01Icon,
  BotIcon,
  BrainIcon,
  CloudIcon,
  Database01Icon,
  GitForkIcon,
  HardDriveIcon,
  Login01Icon,
  Logout01Icon,
  Plug01Icon,
  Route01Icon,
  Shield01Icon,
  WebhookIcon,
  Wrench01Icon,
  type TerraIcon,
} from '@terra/ui-icons';
import type { AiFlowNodeCategory } from './types';

export const AiFlowNodeIconMap: Record<AiFlowNodeCategory, TerraIcon> = {
  AGENT: BotIcon,
  SUB_AGENT: BotIcon,
  LLM: BrainIcon,
  TOOL_FUNCTION: Wrench01Icon,
  TOOL_HOSTED: CloudIcon,
  TOOL_MCP: Plug01Icon,
  SKILL: BookOpen01Icon,
  MIDDLEWARE: GitForkIcon,
  GUARDRAIL: Shield01Icon,
  MEMORY: Database01Icon,
  STATE: HardDriveIcon,
  HOOK: WebhookIcon,
  ROUTER: Route01Icon,
  ENTRY: Login01Icon,
  EXIT: Logout01Icon,
};
export const AiFlowNodeColorMap: Record<AiFlowNodeCategory, string> = {
  AGENT: token('colors.violet.10'),
  SUB_AGENT: token('colors.violet.10'),
  LLM: token('colors.violet.10'),
  TOOL_FUNCTION: token('colors.orange.10'),
  TOOL_HOSTED: token('colors.orange.10'),
  TOOL_MCP: token('colors.orange.10'),
  SKILL: token('colors.orange.10'),
  MIDDLEWARE: token('colors.violet.10'),
  GUARDRAIL: token('colors.crimson.10'),
  MEMORY: token('colors.crimson.10'),
  STATE: token('colors.crimson.10'),
  HOOK: token('colors.violet.10'),
  ROUTER: token('colors.orange.10'),
  ENTRY: token('colors.orange.10'),
  EXIT: token('colors.crimson.10'),
};
export const AiFlowNodeLabelMap: Record<AiFlowNodeCategory, string> = {
  AGENT: 'Agent',
  SUB_AGENT: 'Sub Agent',
  LLM: 'LLM',
  TOOL_FUNCTION: 'Tool',
  TOOL_HOSTED: 'Hosted Tool',
  TOOL_MCP: 'MCP Tool',
  SKILL: 'Skill',
  MIDDLEWARE: 'Middleware',
  GUARDRAIL: 'Guardrail',
  MEMORY: 'Memory',
  STATE: 'State',
  HOOK: 'Hook',
  ROUTER: 'Router',
  ENTRY: 'Entry',
  EXIT: 'Exit',
};
export const AI_FLOW_NODE_DEFAULT_WIDTH = 180;
export const AI_FLOW_NODE_DEFAULT_HEIGHT = 80;
export const CODE_GRAPH_ELIGIBLE_CATEGORIES: Set<AiFlowNodeCategory> = new Set([
  'TOOL_FUNCTION',
  'TOOL_HOSTED',
  'TOOL_MCP',
  'SKILL',
  'MIDDLEWARE',
  'GUARDRAIL',
  'MEMORY',
  'STATE',
  'HOOK',
]);
export const AI_FLOW_GRAPH_COLORS = {
  edge: token('colors.lilac.8'),
  text: token('colors.gray.11'),
  background: token('colors.gray.6'),
} as const;
